import { useQuery } from "@tanstack/react-query";

import { customMaterialsQuery } from "#modules/materials/infra/customMaterials.query";
import { Material } from "#modules/materials/infra/fetchCustomMaterials.api";

export const useCustomMaterials = ({ initialData }: { initialData?: Material[] }) => {
  const { data, ...rest } = useQuery({
    ...customMaterialsQuery(),
    ...(initialData !== undefined && { initialData }),
  });

  return { customMaterials: data ?? [], ...rest };
};
